<template>
    <div class="classify-video-wrap">
        <MaterialTrees type="video" @getItemDetail="getItemDetail"></MaterialTrees>
        <div class="classify-video-content">
            <VideoTopOperateBar
                :tagId="currentTagId"
                :sourceData="sourceData"
                :refercence="refercence"
                @switchClick="switchHandler"
            ></VideoTopOperateBar>
            <div class="classify-video-list">
                <FigureItem
                    v-for="item in classifyVideoData"
                    :key="item.id"
                    :data="item"
                    @checkedClick="itemCheckChange"
                    @editClick="editHandler"
                    @previewClick="previewHandler"
                    :iconConfig="iconData"
                    :tagId="currentTagId"
                    @recommendSuccess="recommendSuccess"
                />
                <span class="no-data-tip" v-if="classifyVideoData.length == 0">无数据</span>
            </div>
            <div class="page-control">
                <BottomOperateBar
                    :allCheck="allCheckFlag"
                    @allCheckChange="allCheckHandler"
                    @deleteClick="deleteChecked"
                    @transferHandle="transferHandle"
                    v-if="!refercence"
                />
                <PageControl :total="totalPage" :curPage="curPage" :pageLength="curPageLen" @pageChange="pageChange" />
                <div class="page-length-rank">
                    <span class="total-num">{{ $t("zhiji.materialLibrary.totalOf") + totalPage }}</span>
                    <PageLengthSelect class="length-rank-robot" :pageRank="pageLengthRank" :curLength="curPageLen" @lengthChange="lengthChange" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MaterialTrees from "@/views/zhiji/components/materialLibrary/MaterialTrees";
import FigureItem from "@/views/zhiji/components/materialLibrary/FigureItem";
import BottomOperateBar from "@/views/zhiji/components/materialLibrary/BottomOperateBar";
import PageControl from "@/views/zhiji/bComponents/pageController/PageControl";
import VideoTopOperateBar from "./VideoTopOperateBar";
import VideoEditModel from "./VideoEditModel";
import PageLengthSelect from "@/views/zhiji/bComponents/pageController/PageLengthSelect";
import ShowVideoViewModal from "@/views/zhiji/components/questionEdit/modals/VideoViewModal";

import { sourceOptions, pageLengthRank } from "@/views/zhiji/components/materialLibrary/materialLibraryConfig.js";
import i18n from "@/i18n";

export default {
    name: "VLinkVideo",
    props: ["refercence"],
    components: {
        MaterialTrees,
        VideoTopOperateBar,
        FigureItem,
        PageControl,
        BottomOperateBar,
        PageLengthSelect
    },
    data() {
        return {
            iconData: {
                previewIcon: "-198px -50px",
                previewHoverIcon: "-198px -74px",
                recommendType: "video"
            },
            curPage: 1,
            curPageLen: 15,
            checkedArr: [],
            pageLengthRank: pageLengthRank,
            currentTagId: "" //当前标签ID
        };
    },
    computed: {
        sourceData() {
            return sourceOptions();
        },
        classifyVideoData() {
            return this.convertListData(this.getStorePorp("videoData"));
        },
        totalPage() {
            return this.getStorePorp("total");
        },
        allCheckFlag() {
            return this.checkedArr.length !== 0 && this.classifyVideoData.length == this.checkedArr.length;
        }
    },
    mounted() {
        this.getClassifyVideoList();
    },
    methods: {
        getStorePorp(propName) {
            return this.$store.state.zhiji.materialLibraryPage[propName];
        },
        recommendSuccess() {
            this.getClassifyVideoList();
        },
        getItemDetail(data) {
            this.currentTagId = data.isRoot ? "" : data.tagId;
            this.curPage = 1;
            this.getClassifyVideoList();
        },
        getClassifyVideoList() {
            this.$store.dispatch("zhiji/queryVideoList", {
                page: this.curPage,
                size: this.curPageLen,
                videoName: "",
                source: "",
                sequence: "",
                lang: "",
                tagId: this.currentTagId,
                usageStatus: ''
            });
        },
        editHandler(data) {
            !this.refercence &&
                this.$store.dispatch("zhiji/showModal", {
                    type: VideoEditModel,
                    data: {
                        type: "edit",
                        videoData: data
                    }
                });
        },
        previewHandler(data) {
            this.$store.commit("zhiji/showModal", {
                type: ShowVideoViewModal,
                data: {
                    url: data.videoUrl
                }
            });
        },
        pageChange(data) {
            if (this.curPageLen == data.pageLength && this.curPage == data.curPage) {
                return;
            }
            this.curPageLen = data.pageLength;
            this.curPage = data.curPage;
            this.$store.dispatch("zhiji/queryVideoList", {
                page: this.curPage,
                size: this.curPageLen
            });
            this.checkedArr = [];
            this.removeAllCheck();
            this.$emit("checkClick", {});
        },
        lengthChange(data) {
            if (this.curPageLen == data) {
                return;
            }
            this.curPageLen = data;
            this.$store.dispatch("zhiji/queryVideoList", {
                page: this.curPage,
                size: this.curPageLen
            });
            this.checkedArr = [];
            this.removeAllCheck();
            this.$emit("checkClick", {});
        },
        itemCheckChange(data) {
            if (data.checked) {
                this.checkedArr.indexOf(data.id) === -1 && this.checkedArr.push(data.id);
            } else {
                let itemcheckedIdx = this.checkedArr.indexOf(data.id);
                itemcheckedIdx !== -1 && this.checkedArr.splice(itemcheckedIdx, 1);
            }
            this.$emit("checkClick", data);
        },
        allCheckHandler(data) {
            data.checked ? this.addAllCheck() : this.removeAllCheck();
        },
        addAllCheck() {
            this.classifyVideoData.forEach(item => {
                this.itemCheckChange({
                    id: item.id,
                    checked: true
                });
            });
        },
        removeAllCheck() {
            this.checkedArr.splice(0);
        },
        deleteChecked() {
            let configText = i18n.t("zhiji.materialLibrary.delVideoConfim");
            const videoInUseText = i18n.t("zhiji.materialLibrary.prohibitDeleUsingStrate");
            this.checkedArr.length === 0
                ? (configText = i18n.t("zhiji.materialLibrary.optVideoWarn"))
                : this.checkedArr.length > 1
                ? (configText = i18n.t("zhiji.materialLibrary.delVideosConfim"))
                : "";

            const videoInUse = this.classifyVideoData.some((videoDataItem) => {
                return this.checkedArr.some((CheckedItem) => {
                    if (videoDataItem.id !== CheckedItem) {
                        return false;
                    }
                    return videoDataItem.relevanceStdQuestionIds && videoDataItem.relevanceStdQuestionIds.length > 0;
                });
            });
            if (videoInUse) {
                this.$store.dispatch("zhiji/showModal", {
                    type: "MessageModal",
                    data: {
                        type: "error",
                        message: videoInUseText,
                    },
                });
            } else {
                this.$store.dispatch("zhiji/showModal", {
                    type: "MessageModal",
                    data: {
                        type: "tip",
                        message: configText,
                        confirm: () => {
                            if (this.checkedArr.length > 0) {
                                this.deleteVideo();
                                this.removeAllCheck();
                            }
                        }
                    }
                });
            }
        },
        transferHandle(datas) {
            if (this.checkedArr.length > 0) {
                this.zhiji
                    .requestByServiceName("transferVideo", {
                        ids: this.checkedArr.join(","),
                        tag_new_ids: datas.join(",")
                    })
                    .then(resp => {
                        if (resp == "success") {
                            this.$store.dispatch("zhiji/queryVideoList", {
                                page: this.curPage,
                                size: this.curPageLen
                            });
                            this.checkedArr.splice(0);
                        }
                    })
            } else {
                this.$store.dispatch("zhiji/showModal", {
                    type: "MessageModal",
                    data: {
                        type: "error",
                        message: i18n.t("请至少选择一条视频")
                    }
                });
            }
        },
        deleteVideo() {
            this.zhiji
                .requestByServiceName("deleteVLinkVideo", {
                    videoIds: this.checkedArr.join(",")
                })
                .then(() => {
                    this.$store.dispatch("zhiji/queryVideoList", {
                        page: this.curPage,
                        size: this.curPageLen
                    });
                });
        },
        convertListData(data) {
            return data.map(item => {
                return {
                    ...item,
                    checked: this.getCheckState(item.id)
                };
            });
        },
        getCheckState(id) {
            return this.checkedArr.some(itemId => itemId === id);
        },
        switchHandler() {
            this.curPage = 1;
            this.checkedArr = [];
            this.$emit("checkClick", {});
        }
    }
};
</script>

<style scoped lang="less">
.classify-video-wrap {
    height: 100%;
    display: flex;
    .classify-video-content {
        display: flex;
        flex: 1;
        flex-direction: column;
        .classify-video-list {
            display: flex;
            flex: 1;
            justify-content: flex-start;
            align-content: flex-start;
            flex-wrap: wrap;
            background-color: #fff;
            padding: 24px 0 24px 24px;
            box-sizing: border-box;
            overflow-y: auto;
            .no-data-tip {
                flex: 1;
                text-align: center;
                margin-top: -10px;
                color: #9b9ba3;
            }
        }
        .page-control {
            position: relative;
            width: 100%;
            padding: 20px 0;
            text-align: center;
            background: #f2f7fb;
            .page-length-rank {
                margin-right: 20px;
                float: right;
                margin-top: 6px;
                .total-num {
                    font-weight: 700;
                    margin-right: 10px;
                }
                .length-rank-robot {
                    top: -2px;
                }
            }
        }
    }
}
</style>
